import React from "react";
import { byAPrefix, byCodes } from "../../../../constant/General";
import ContentWrapper from "../../mt/ContentWrapper";
import DrawingTable from "./DrawingTable";
import ResultTable from "./ResultTable";





const ResultKPNight = (props) => {

    const { result, config } = props;

    const post = {
        postBCD: byCodes(result.rightResults, ["B", "C", "D"]),
        postA3D: byAPrefix(result.rightResults, 3),
        postA2D: byAPrefix(result.rightResults, 4),
    };

    return <ContentWrapper id="live-v2-kp">
        <DrawingTable {...props} />
        <ResultTable post={post} config={config} />
    </ContentWrapper>
}

export default ResultKPNight;